<template>
    <tr class="card-header p-0 border">
        <td class="p-3 text-center">
            <i v-if="returnShipment.address" class="fa-solid fa-box-open nav-icon text-primary pl-3"></i>
            <i v-else class="fa-solid fa-hand nav-icon text-danger pl-3"></i>
        </td>
        <td v-if="returnShipment.address" colspan="100%">
            <div class="row align-items-center pl-3 pr-3">
                <div class="col-md">
                    <h4 class="m-0">{{ returnShipment.address?.address1 }}
                    </h4>
                    <h4 v-if="returnShipment.address?.address2" class="m-0">{{
                        returnShipment.address?.address2 }}</h4>
                    <h4>{{ returnShipment.address?.city }}, {{
                        returnShipment.address?.state
                    }} {{ returnShipment.address?.postcode }}
                    </h4>
                </div>
                <div v-if="returnShipment.address" class="col-md-auto text-right">
                    <template v-if="returnShipment.address && submitted">
                        <div class="p-2">
                            <a v-if="returnShipment.label_url" :href="returnShipment.label_url" target="_blank">
                                <jet-button class="ShippingPrintButton mr-3" icon="fas fa-print">Shipping
                                    Label</jet-button></a>
                            <jet-button class="ShippingPrintButton" @click="print(returnShipment.id)"
                                icon="fas fa-print">Packing
                                Slip</jet-button>
                        </div>
                        <span class="text-success pr-2">
                            Please Include a Packing Slip in the Shipment
                        </span>
                    </template>
                    <div v-else class="text-right pl-3">
                        <SelectButton class="ShippingSelectButton" v-model="returnShipment.shipType"
                            :options="['Self Ship', 'Provide Label']" />
                    </div>
                </div>
            </div>
        </td>
        <td v-else colspan="3" class="pl-3">
            <h4 class="text-danger m-0 mr-3">These items do <strong>NOT</strong> need to be
                returned</h4>
        </td>
    </tr>
    <template v-for="returnItem in returnShipment.return_items">
        <ReturnItem :returnItem="returnItem" :showOutcome="!isCheckout"
            :showActionButtons="returnShipment.status == 'Processing'" :isAdminView="isAdminView" 
            @returnItemChanged="returnItemChanged"/>
    </template>
    <tr class="border">
        <td class="pt-2 pb-2 pl-3 text-right font-weight-bold" colspan="2">
            <div>Total Items</div>
            <div v-if="hasShippingCharge && returnShipment.shipping_charge > 0"
                class="text-danger">Shipping</div>
            <div v-if="returnShipment.address">
                Total Credit
            </div>
        </td>
        <td class="pt-2 pb-2 pr-3 text-left  font-weight-bold">
            <div class="ml-3 text-center">
                {{
                    returnShipment.return_items.reduce((total, warrantyCartItem) => {
                        return total + warrantyCartItem.quantity
                    }, 0) }}
            </div>
            <div v-if="hasShippingCharge && returnShipment.shipping_charge > 0"
                class="ml-3 text-danger">{{
                    formatDollars(-returnShipment.shipping_charge) }}</div>
            <div v-if="returnShipment.address" class="ml-3">
                {{ formatDollars(returnShipment.total_credit -
                    (hasShippingCharge ? returnShipment.shipping_charge : 0))
                }}
            </div>
        </td>
    </tr>
</template>

<script>
import ReturnItem from './ReturnItem.vue';
import SelectButton from 'primevue/selectbutton';
import JetButton from '@/Jetstream/Button';

export default {
    emits: ['printPackingSlip','returnItemChanged'],
    components: {
        ReturnItem,
        SelectButton,
        JetButton,
    },
    props: {
        returnShipment: Object,
        isCheckout: {
            type: Boolean,
            default: false,
        },
        submitted: {
            type: Boolean,
            default: false,
        },
        isAdminView: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasShippingCharge () {
            return this.returnShipment?.shipType == 'Provide Label' || this.returnShipment?.label_url
        }
    },
    methods: {
        print(id) {
            this.$emit('printPackingSlip', id)
        },
        returnItemChanged() {
            this.$emit('returnItemChanged');
        },
    },
}
</script>